/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Partner_Org_TitleInputs */



/**
* | output |
* | --- |
* | "Plan purchases unavailable" |
*
* @param {Pricing_Partner_Org_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_partner_org_title = /** @type {((inputs?: Pricing_Partner_Org_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Partner_Org_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarifkauf nicht verfügbar")
	return /** @type {LocalizedString} */ ("Plan purchases unavailable")
});